/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_CreatedInputs */

const cs_blog_created = /** @type {(inputs: Blog_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Článek vytvořen`)
};

const en_blog_created = /** @type {(inputs: Blog_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Article created`)
};

/**
* | output |
* | --- |
* | "Article created" |
*
* @param {Blog_CreatedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_created = /** @type {((inputs?: Blog_CreatedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_CreatedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_created(inputs)
	return cs_blog_created(inputs)
});